<div class="transfer-dialog" [class.danger]="mode() === 'delete'">
  <div class="dialog-header">
    <div class="title">
      <fa-duotone-icon [icon]="faStar"></fa-duotone-icon>
      <span>{{ 'Make "[role]" the default team' | translate: { role: data.newDefaultName } }}</span>
    </div>
    <button
      type="button"
      class="close-btn"
      [attr.aria-label]="'Close' | translate"
      [andorTooltip]="'Close' | translate"
      tooltipPosition="below"
      (click)="cancel()">
      <fa-duotone-icon [icon]="faXmark"></fa-duotone-icon>
    </button>
  </div>

  <andor-notice variant="warning">
    {{
      'Everyone visiting the app will automatically get the privileges of "[role]".'
        | translate: { role: data.newDefaultName }
    }}
    {{
      '"[role]" is no longer the default team and needs a password — choose what happens to it:'
        | translate: { role: data.oldDefaultName }
    }}
  </andor-notice>

  <div class="mode-options">
    <button
      type="button"
      class="mode-option"
      [class.active]="mode() === 'password'"
      (click)="mode.set('password')">
      {{ 'Set a new password' | translate }}
    </button>
    <button
      type="button"
      class="mode-option"
      [class.active]="mode() === 'delete'"
      (click)="mode.set('delete')">
      {{ 'Delete "[role]"' | translate: { role: data.oldDefaultName } }}
    </button>
  </div>

  @if (mode() === 'password') {
    <andor-password-confirm-inputs
      [password]="password()"
      (changed)="password.set($event)"
      (valid)="passwordValid.set($event)"></andor-password-confirm-inputs>
    <p class="hint">
      {{
        'Members of "[role]" are signed out and must re-enter the new password.'
          | translate: { role: data.oldDefaultName }
      }}
    </p>
  } @else {
    <andor-notice variant="error">
      {{
        'The team "[role]" is removed permanently and all its members are signed out.'
          | translate: { role: data.oldDefaultName }
      }}
    </andor-notice>
  }

  <div class="actions">
    <button type="button" class="cancel" (click)="cancel()">
      {{ 'Cancel' | translate }}
    </button>
    <button
      type="button"
      class="confirm"
      [class.danger]="mode() === 'delete'"
      [disabled]="!canConfirm()"
      (click)="confirm()">
      {{ 'Transfer' | translate }}
    </button>
  </div>
</div>
